import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './News.css';
import { newsData } from '../NewsData';
import NewsCards  from "../NewsCards";

const News = () => {
  const { t } = useTranslation();
  const newsRefs = useRef({});
  const [currentImageIndices, setCurrentImageIndices] = useState({});
  const data = newsData(t);

  useEffect(() => {
    const initialIndices = {};
    data.forEach(news => {
      initialIndices[news.id] = 0;
    });
    setCurrentImageIndices(initialIndices);
  }, []);

  // Автоматическая смена изображений
  useEffect(() => {
    const intervals = {};
    
    data.forEach(news => {
      if (news.images.length > 1) {
        intervals[news.id] = setInterval(() => {
          setCurrentImageIndices(prev => ({
            ...prev,
            [news.id]: (prev[news.id] + 1) % news.images.length
          }));
        }, 3000);
      }
    });

    return () => {
      Object.values(intervals).forEach(interval => clearInterval(interval));
    };
  }, []);

  const goToPrevious = (id) => {
    setCurrentImageIndices(prev => ({
      ...prev,
      [id]: prev[id] === 0 ? data.find(n => n.id === id).images.length - 1 : prev[id] - 1
    }));
  };

  const goToNext = (id) => {
    setCurrentImageIndices(prev => ({
      ...prev,
      [id]: (prev[id] + 1) % data.find(n => n.id === id).images.length
    }));
  };

  const goToImage = (id, index) => {
    setCurrentImageIndices(prev => ({
      ...prev,
      [id]: index
    }));
  };

  return (
    <div className="news-page" id="main">
      <div className="news-transparent-box">
        <div className="hero-section">
          <h1>{t('news.welcome')}</h1>
          <p>{t('news.main_title')}</p>
        </div>
      </div>
      
      <NewsCards/>
      
      <div className="news-list">
        {data.map(news => (
          <article 
            key={news.id} 
            className="news-article" 
            ref={el => newsRefs.current[news.id] = el}
            id={`news-${news.id}`}
          >
            <h2>{news.title}</h2>
            <p className="news-date">{news.date}</p>
            
            <div className="news-image-container">
              {news.images.length > 1 && (
                <button 
                  className="image-nav-button prev-button" 
                  onClick={() => goToPrevious(news.id)}
                >
                  &#10094;
                </button>
              )}
              
              <img 
                src={news.images[currentImageIndices[news.id] || 0]} 
                alt={`${news.title} - ${(currentImageIndices[news.id] || 0) + 1}`} 
                className="news-image"
              />
              
              {news.images.length > 1 && (
                <button 
                  className="image-nav-button next-button" 
                  onClick={() => goToNext(news.id)}
                >
                  &#10095;
                </button>
              )}
              
              {news.images.length > 1 && (
                <div className="image-indicators">
                  {news.images.map((_, index) => (
                    <span 
                      key={index}
                      className={`indicator ${index === (currentImageIndices[news.id] || 0) ? 'active' : ''}`}
                      onClick={() => goToImage(news.id, index)}
                    />
                  ))}
                </div>
              )}
            </div>
            
            <div className="news-content">
              {news.content.map((item, i) => {
                if (item.type === 'paragraph') {
                  return <p key={i}>{item.text}</p>;
                } else if (item.type === 'bulletList') {
                  return (
                    <ul key={i} className="news-bullet-points">
                      {item.items.map((point, j) => (
                        <li key={j}>{point}</li>
                      ))}
                    </ul>
                  );
                }
                return null;
              })}
            </div>
            
          </article>
        ))}
      </div>
    </div>
  );
};

export default News;